/* eslint-disable no-caller */
/* eslint-disable no-throw-literal */
/* eslint-disable no-prototype-builtins */
/* eslint-disable unicorn/error-message */
/* eslint-disable no-sequences */
/* eslint-disable no-lonely-if */
/* eslint-disable no-new-func */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-undef */
/**
 * Created by bear on 17/07/06.
 * util类挂常用方法集
 */

import md5 from 'md5'
import reqwestJs from '../lib/reqwest.js'
import clipboardJs from '../lib/clipboard.js'

// 轻量 querystring 实现（避免依赖 Node 内置模块）
const querystring = {
  parse(str) {
    if (!str) return {}
    const source = str.charAt(0) === '?' ? str.slice(1) : str
    const result = {}
    const pairs = source.split('&')
    for (let i = 0; i < pairs.length; i++) {
      const part = pairs[i]
      if (!part) continue
      const eqIndex = part.indexOf('=')
      let key, value
      if (eqIndex === -1) {
        key = part
        value = ''
      } else {
        key = part.slice(0, eqIndex)
        value = part.slice(eqIndex + 1)
      }
      try {
        key = decodeURIComponent(key.replace(/\+/g, ' '))
      } catch (e) {}
      try {
        value = decodeURIComponent(value.replace(/\+/g, ' '))
      } catch (e) {}
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        const current = result[key]
        if (Array.isArray(current)) {
          current.push(value)
        } else {
          result[key] = [current, value]
        }
      } else {
        result[key] = value
      }
    }
    return result
  },
  stringify(obj) {
    if (!obj || typeof obj !== 'object') return ''
    const parts = []
    const encode = (v) => encodeURIComponent(String(v)).replace(/%20/g, '+')
    for (const key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue
      const value = obj[key]
      const encodedKey = encode(key)
      if (value == null) {
        parts.push(encodedKey + '=')
      } else if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          parts.push(encodedKey + '=' + encode(value[i]))
        }
      } else {
        parts.push(encodedKey + '=' + encode(value))
      }
    }
    return parts.join('&')
  }
}

// 加载文件缓存
const dealData = {}

// 获取浏览器ua
export function getBrowserUA() {
  const ua = window.navigator.userAgent.toLowerCase()

  _SDKApp.browser = 'pc'

  // 解决那些令人蛋疼的乱改ua标识
  if (ua.match(/(mobile)|(android)|(Safari)/gi)) {
    if (ua.includes('android')) {
      _SDKApp.browser = 'android'
    }

    if (ua.includes('iphone') || ua.includes('ipad')) {
      _SDKApp.browser = 'iOS'
    }

    if (ua.includes('micromessenger')) {
      _SDKApp.browser = 'wechat'
    }
  }

  return _SDKApp.browser
}

export function getTopLevelDomain() {
  _SDKApp.topLevelDomain = document.domain
    .split('.')
    .slice(-2)
    .join('.')
  return _SDKApp.topLevelDomain
}

// 初始化需要先执行的方法类
export function initPage() {
  let pageInfo

  window._SDKApp = {
    load: '',
    conf: window._SDKCommonConf
  }

  _SDKApp.load.includes('clientGame')
    ? (pageInfo = '端游产品')
    : (pageInfo = '页游产品')

  statipPageLoadedClient()
  setControlDownload(true)
  getBrowserUA()
  getTopLevelDomain()

  log(
    '%cSDK环境已加载：' + _SDKApp.load + '\n' + pageInfo,
    'line-height:30px;font-size:16px;font-weight:700;color:#007ACC;'
  )
}

// 页面加载时执行
export function addReadyEvent(fn, context = undefined) {
  const document = context || window.document

  if (document.readyState === 'complete') {
    return fn()
  }

  if (document.addEventListener) {
    const completed = function() {
      window.removeEventListener('load', completed, false)
      fn()
    }

    window.addEventListener('load', completed, false)
  } else if (document.attachEvent) {
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState === 'complete') {
        // tslint:disable-next-line
        document.detachEvent('onreadystatechange', arguments.callee)
        fn()
      }
    })
  } else if (document.lastChild === document.body) {
    fn()
  }
}

// 页面加载完毕时执行
export function addLoadEvent(fn) {
  const oldonload = window.onload

  if (typeof window.onload !== 'function') {
    window.onload = fn
  } else {
    window.onload = function() {
      oldonload()
      fn()
    }
  }
}

let reqwest

// 跟jQuery.ajax类似
export async function getAjax(param) {
  const { dataType } = param

  let result = null
  if (window.jQuery) {
    result = jQuery.ajax(param)
  } else if (dataType === 'script') {
    result = await loadFile(param)
  } else if (dataType === 'jsonp') {
    result = await ajaxJsonp(param)
  } else {
    reqwest = reqwest || reqwestJs()
    result = reqwest(param)
  }
  return result
}

export function ajaxJsonp(opts) {
  const url = opts.url // url参数，必填
  const jsonpCallback = opts.jsonpCallback || opts.jsonp || 'callback' // jsonp函数名，必填
  const success = opts.success // 成功回调，可选
  const error = opts.error // 错误回调，可选
  const data = opts.data || {} // 地址参数，可选
  const timeOut = opts.timeOut // 请求超时，可选

  if (!url) {
    throw 'url必填!'
  }

  const nonce = String(Math.random()).replace(/\D/, '')
  const callbackName = 'jsonp_' + nonce
  const head = document.getElementsByTagName('head')[0]
  const script = document.createElement('script')

  data[jsonpCallback] = callbackName

  const params = objectToQuery(data)

  return new Promise((resolve, reject) => {
    window[callbackName] = function() {
      head.removeChild(script)
      window[callbackName] = undefined
      clearTimeout(script.timeOutHandle)
      success && success(arguments[0])
      resolve(arguments[0])
    }

    script.src = url + (url.includes('?') ? '&' : '?') + params
    head.appendChild(script)

    if (timeOut) {
      script.timeOutHandle = setTimeout(() => {
        head.removeChild(script)
        window[callbackName] = undefined
        error &&
          error({
            message: '请求超时！'
          })
        reject({
          message: '请求超时！'
        })
      }, timeOut)
    }
  })
}

// 获取接口数据，封装的promise
export async function loadData(param) {
  try {
    // 默认10s超时
    param.timeOut ? null : (param.timeOut = 10000)

    const res = await getAjax(param)

    if (res != null && res.status === 400) {
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          param.success && param.success()
          resolve()
        }, 1500)
      })

      return await getAjax(param)
    }

    return res
  } catch (e) {
    // throw new TypeError(e);
    return e
  }
}

// 加载js、css
export function loadFile(param) {
  const { url, fn, error } = param
  let { success } = param
  success = fn || success
  let result = null

  if (typeof url === 'object') {
    const loadFiles = url.map((url) => loadFile({ url }))
    result = new Promise((resolve, reject) => {
      Promise.all(loadFiles).then(() => {
        success && success()
        resolve()
      })
    })
  } else if (typeof url === 'string') {
    result = new Promise((resolve, reject) => {
      if (dealData[url]) {
        if (dealData[url] === 'loaded') {
          success && success()
          resolve()
        }
        return
      }

      const IS_JS = url.includes('.js')

      if (IS_JS) {
        const script = document.createElement('script')
        const operDom = document.body
          ? document.body
          : document.getElementsByTagName('head')[0]

        if (script.readyState) {
          // IE
          script.onreadystatechange = function() {
            if (
              script.readyState === 'loaded' ||
              script.readyState === 'complete'
            ) {
              script.onreadystatechange = null
              dealData[url] = 'loaded'
              success && success()
              resolve()
            }
          }
        } else {
          script.onload = () => {
            operDom.removeChild(script)
            dealData[url] = 'loaded'
            success && success()
            resolve()
          }
          script.onerror = (e) => {
            dealData[url] = 'fail'
            error && error(e)
            reject(e)
          }
        }

        script.type = 'text/javascript'
        script.src = url

        operDom.appendChild(script)
      } else {
        const link = document.createElement('link')

        link.type = 'text/css'
        link.rel = 'stylesheet'
        link.href = url
        link.onload = () => {
          dealData[url] = 'loaded'
          resolve()
        }

        document.getElementsByTagName('head')[0].appendChild(link)
      }

      dealData[url] = 'loading'
    })
  }

  return result
}

// cookie操作
export function dealCookie(name, value, opt) {
  // set cookie
  if (typeof value !== 'undefined') {
    // name and value given, set cookie
    const options = opt || {}

    if (value === null) {
      options.expires = -1
    }

    let expires = ''

    if (
      options.expires &&
      (typeof options.expires === 'number' || options.expires.toUTCString)
    ) {
      let date

      if (typeof options.expires === 'number') {
        date = new Date()
        date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000)
      } else {
        date = options.expires
      }

      // use expires attribute, max-age is not supported by IE
      expires = '; expires=' + date.toUTCString()
    }

    const path = '; path=' + (options.path || '/')
    const domain = '; domain=' + (options.domain || location.hostname)
    const secure = options.secure ? '; secure=' + options.secure : ''

    document.cookie = [
      name,
      '=',
      encodeURIComponent(value || ''),
      expires,
      path,
      domain,
      secure
    ].join('')
  } else {
    // only name given, get cookie
    let cookieValue = null

    if (document.cookie && document.cookie !== '') {
      const cookies = document.cookie.split(';')

      for (let i = 0, len = cookies.length; i < len; i += 1) {
        const cookie = (cookies[i] || '').replace(/^\s+|\s+$/g, '')
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) === name + '=') {
          try {
            cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
          } catch (e) {
            dealCookie(name, null)
            cookieValue = null
          }
          break
        }
      }
    }
    return cookieValue
  }
}

export function clearAllCookie(domain, path) {
  const keys = document.cookie.match(/[^ =;]+(?=\=)/g)
  if (keys) {
    for (let i = keys.length; i > 0; i -= 1) {
      document.cookie =
        keys[i] +
        '=0; expires=' +
        new Date().toUTCString() +
        (domain ? '; domain=' + domain : '') +
        (path ? '; path=' + path : '/')
    }
  }
}

// console
export const log = (method, ...res) => {
  const methods = ['log', 'info', 'dir', 'error', 'warn']

  if (
    Function.prototype.bind &&
    window.console &&
    typeof console.log === 'function'
  ) {
    methods.includes(method)
      ? console[method](...res)
      : console.log(method, ...res)
  }
}

// 剪贴板
export function clipboard(opt) {
  const { txt, success, error } = opt

  if (window.clipboardData) {
    try {
      clipboardData.clearData()
      clipboardData.setData('Text', txt)
      success && success()
    } catch (e) {
      error && error('当前浏览器不支持复制操作，请手动复制!')
    }
  } else {
    // other/clipboard.js
    const result = clipboardJs(txt)
    if (result) {
      success && success()
    } else {
      error && error('当前浏览器不支持复制操作，请手动复制!')
    }
  }
}

// 获取url参数，不对value带有#特殊字符做处理
export function getParam(paramName, param) {
  let paramValue = ''
  let isFound = false
  const href = param || window.location.href
  let search = ''

  if (href.indexOf('?') > 1) {
    const searchs = href.split('?')

    searchs.shift()
    search = searchs.join('')

    const arrSource = search.split('&')
    let i = 0

    while (i < arrSource.length && !isFound) {
      if (arrSource[i].indexOf('=') > 0) {
        if (
          arrSource[i].split('=')[0].toLowerCase() === paramName.toLowerCase()
        ) {
          paramValue = arrSource[i].split('=')[1]
          isFound = true
        }
      }
      i += 1
    }
  }

  // 原封不动返回取到的数值，不需encode
  // 防止有可能出现的数值只是随机生成的含有特殊字符的字符串
  return paramValue
}

// 获取query
export function getQueryString(name, search) {
  const str = search || window.location.search.substr(1)
  let result = querystring.parse(str)[name]
  // 当有重复参数时querystring.parse返回的是数组
  if (Array.isArray(result)) {
    result = result[0]
  }
  return result || null
}

// 对象转query字符串
export function objectToQuery(obj) {
  return querystring.stringify(obj)
}

export function json2str(o) {
  const arr = []
  const fmt = function(s) {
    if (typeof s === 'object' && s != null) return json2str(s)
    return /^(string|number)$/.test(typeof s) ? '"' + s + '"' : s
  }

  for (const i in o) arr.push('"' + i + '":' + fmt(o[i]))

  return '{' + arr.join(',') + '}'
}

// 对象复制
export const assign = Object.assign

// 随机打乱数组
export function randomArray(arr) {
  return arr.sort(() => {
    return Math.random() - 0.5
  })
}

// 手机号码验证
export function mobileReg(mobile) {
  return /0?(12|13|14|15|16|17|18|19)[0-9]{9}$/.test(mobile)
}

// 时间戳转换成指定格式日期，默认 yyyy-MM-dd hh:mm:ss 格式
// 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
// 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
// 例子：
// date("1460712404808") ==> 2006-07-02 08:09:04
// date("1460712404808","yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
export function formaDate(s, fmt) {
  let date = null

  if (typeof s === 'object') {
    date = s
  } else {
    const timestamp = typeof s === 'string' ? Number(s) : s
    date = new Date(timestamp)
  }

  let format = fmt || 'yyyy-MM-dd hh:mm:ss'

  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }

  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }

  for (const k in o) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }

  return format
}

// 兼容错别字
export const formatDate = formaDate

// 获取数组最大值、最小值
export function getArrayVal(count, arr, compeVal) {
  let ary = arr[0]
  const len = arr.length
  const isMax = count === 'max'

  if (!compeVal) {
    return Math[count].apply({}, arr)
  }

  for (let i = 1; i < len; i += 1) {
    if (isMax) {
      if (Number(arr[i][compeVal]) > Number(ary[compeVal])) {
        ary = arr[i]
      }
    } else if (Number(arr[i][compeVal]) < Number(ary[compeVal])) {
      ary = arr[i]
    }
  }

  return ary
}

/** 随机字符串 */
export function getRandomString(length) {
  let randomString = ''
  const word = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < length; i += 1) {
    randomString += word.charAt(Math.floor(Math.random() * word.length))
  }
  return randomString
}

// string2json
// tslint:disable-next-line
export function JSONParse(str) {
  // tslint:disable-next-line
  return new Function('return ' + str)()
}

// game.js => goa游戏数据转换
export function queryGame(gameID, queryParam) {
  try {
    return window.games[gameID][queryParam]
  } catch (e) {
    return log(e)
  }
}

// 获取当前环境信息
export function getCurrentENV() {
  let env = 'browser'

  if (xlQuickLogin.isTbcClient()) {
    env = 'tbcClient'
  }

  return env
}

export function isChromeAndVersionAbove80() {
  const ua = navigator.userAgent.toLowerCase()
  const chromeMatch = ua.match(/chrome\/([\d.]+)/)
  const chromeVersion = chromeMatch ? chromeMatch[1] : '0'
  const isVersionAbove80 = parseInt(chromeVersion) >= 80
  const isFlash = !!navigator.mimeTypes['application/x-shockwave-flash']
  return isVersionAbove80 && !isFlash
}

// 获取当前环境信息
export function isGoToLoginLink() {
  const httpsProtocol = 'http:'
  const localProtocol = location.protocol
  const isHttp = localProtocol === httpsProtocol
  const isVersionAbove80 = isChromeAndVersionAbove80()
  return isVersionAbove80 && isHttp
}

// 4366域
export function isDomain(str) {
  return window.location.hostname.toLowerCase().includes(str)
}

// 计算页面加载耗时
export function pageLoadedTime(param) {
  addReadyEvent(() => {
    window._PageReadyTime = +new Date()

    f2eGame.port.statpid.loginStat(param)
  })
}

// 客户端耗时上报
export function statipPageLoadedClient() {
  const key = getQueryString('airKey')
  const code = getQueryString('code')

  addReadyEvent(() => {
    window._PageReadyTime = +new Date()
  })

  if (!key) return

  addLoadEvent(() => {
    const dur = +new Date() - window._PageReadyTime
    const desc = 'WebPage/Loaded/' + key + '/' + code

    try {
      window.external.ReportWithEidAndDescEx(desc, desc, 'dur=' + dur)
    } catch (e) {}
  })
}

// 下载按钮配置
// @param isInit 用于页面初始化用
// cookie名为dsfrom，用于登录数据rso参数上报
export function setControlDownload(isInit) {
  let cookieName = 'yycgame_ds_'
  const fromParamVal = getQueryString('dsfrom')
  const gameId = window.location.host.split('.')[0].toUpperCase()
  // tslint:disable-next-line
  const _SDKConf = _SDKApp.conf

  // 设置上报rso数据
  if (fromParamVal) {
    const opt = {}

    dealCookie('dsfrom', fromParamVal, opt)
  }

  if (!_SDKConf.gameAppID[gameId]) {
    return
  }

  const gameAppId = _SDKConf.gameAppID[gameId].appId

  cookieName += gameAppId

  const yycgameCookieVal = dealCookie(cookieName) // 获取下载cookie
  const formalCookieVal = dealCookie('permanent_cookie_' + gameAppId) // 正式cookie
  const tempCookieVal = dealCookie('temp_cookie_' + gameAppId) // 临时cookie

  if (isInit) {
    if (fromParamVal) {
      // 设置临时cookie
      dealCookie('temp_cookie_' + gameAppId, fromParamVal)

      if (!formalCookieVal) {
        dealCookie(cookieName, fromParamVal, { expires: 3 })
      }

      dealCookie('dsfrom', fromParamVal, { expires: 3 })
    } else if (yycgameCookieVal) {
      dealCookie('dsfrom', yycgameCookieVal, { expires: 3 })
    }
  } else if (fromParamVal) {
    if (tempCookieVal) {
      dealCookie(cookieName, tempCookieVal, { expires: 30 })
      dealCookie('permanent_cookie_' + gameAppId, tempCookieVal, {
        expires: 30
      })
    } else {
      // 若没有临时cookie，则写入dsfrom为永久cookie
      dealCookie(cookieName, fromParamVal, { expires: 30 })
      dealCookie('permanent_cookie_' + gameAppId, fromParamVal, { expires: 30 })
    }
  } else {
    // 若不存在dsfrom但有临时cookie，设置临时cookie为30天
    if (tempCookieVal) {
      dealCookie(cookieName, tempCookieVal, { expires: 30 })
      dealCookie('permanent_cookie_' + gameAppId, tempCookieVal, {
        expires: 30
      })
    } else {
      // 将旧的cookie设为30天
      dealCookie(cookieName, tempCookieVal, { expires: 30 })
      dealCookie('permanent_cookie_' + gameAppId, yycgameCookieVal, {
        expires: 30
      })
    }
  }
}

// 生成游戏链接
export function getGameLink(options) {
  const pro = options.pro || 'xl_web'
  const gameId = options.gameId
  const serverId = options.serverId
  const server_code = options.server_code
  const referrer = (options.eid || '').replace(/click\//i, '')
  // tslint:disable-next-line
  const referrer_desc = (options.eid_desc || '').replace('点击/', '')
  // 其它上报数据
  const ext = options.ext

  const href = 'http://wan.xunlei.com/game-offical/'

  let url =
    href +
    gameId +
    '/play' +
    '?&server_id=' +
    serverId +
    '&pro=' +
    pro +
    '&referrer=' +
    referrer +
    '&referrer_desc=' +
    encodeURIComponent(referrer_desc)
  if (server_code) {
    url += '&server_code=' + server_code
  }
  if (ext) {
    url += '&' + ext
  }
  return url
}

// 生成自定义url链接
export function createURL(url, opt) {
  const arrSource = url.split('?')
  const { ...param } = opt
  let mark = '&'
  let key = 1

  if (arrSource.length === 1) {
    ;(arrSource[1] = ''), (mark = '')
  }

  param.url ? ((arrSource[0] = param.url), delete param.url) : null

  for (const i in param) {
    if (arrSource[1] && arrSource[1].includes(i)) {
      const reg = new RegExp(`(${i})=[^&]+`)

      arrSource[1] = arrSource[1].replace(reg, `$1=${opt[i]}`)
    } else {
      key > 1 ? (mark = '&') : null
      arrSource[1] += `${mark}${i}=${opt[i]}`
    }

    key += 1
  }

  return arrSource.join('?')
}

// 获取浏览器信息
export function getBrowserVersion() {
  const result = {
    browser: 'unknown', // 浏览器名称
    version: 'unknown', // 浏览器版本号
    majorVersion: 0 // 浏览器主版本号
  }

  const ua = navigator.userAgent.toLowerCase()

  if (ua.match(/chrome/)) {
    result.browser = 'chrome'
    result.version = ua.match(/chrome\/([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/chrome\/([\d]+)/)[1])
  }

  if (ua.match(/firefox/)) {
    result.browser = 'firefox'
    result.version = ua.match(/firefox\/([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/firefox\/([\d]+)/)[1])
  }

  // edge的ua也包含chrome字段
  if (ua.match(/edge/)) {
    result.browser = 'edge'
    result.version = ua.match(/edge\/([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/edge\/([\d]+)/)[1])
  }

  if (ua.match(/opera/)) {
    result.browser = 'opera'
    result.version = ua.match(/opera\/([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/opera\/([\d]+)/)[1])
  }

  if (ua.match(/safari/)) {
    result.browser = 'safari'
    result.version = ua.match(/version\/([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/version\/([\d]+)/)[1])
  }

  if (ua.match(/msie/)) {
    result.browser = 'ie'
    result.version = ua.match(/msie\s([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/msie\s([\d]+)/)[1])
    // ie11没有msie
  } else if (ua.match(/trident\/7/)) {
    result.browser = 'ie'
    result.version = ua.match(/rv\:([\d.]+)/)[1]
    result.majorVersion = Number(ua.match(/rv\:([\d]+)/)[1])
  }

  return result
}

export function isArray(vArg) {
  return Object.prototype.toString.call(vArg) === '[object Array]'
}

export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

export function filter(target, fn) {
  const arr = []

  if (typeof fn === 'function') {
    for (let k = 0, length = target.length; k < length; k += 1) {
      fn.call(arguments[1], target[k], k, target) && arr.push(target[k])
    }
  }

  return arr
}

export function map(target, fn) {
  const arr = []

  if (typeof fn === 'function') {
    for (let k = 0, length = target.length; k < length; k += 1) {
      arr.push(fn.call(arguments[1], target[k], k, target))
    }
  }

  return arr
}

export function forEach(target, fn) {
  for (let i = 0, len = target.length; i < len; i += 1) {
    if (i in target) {
      fn.call(arguments[1], target[i], i, target)
    }
  }
}

export function every(target, callback) {
  // 获取数组长度
  const len = target.length

  if (typeof callback !== 'function') {
    throw new TypeError()
  }

  // thisArg为callback 函数的执行上下文环境
  const thisArg = arguments[1]

  for (let i = 0; i < len; i += 1) {
    if (i in this && !callback.call(thisArg, this[i], i, this)) {
      return false
    }
  }

  return true
}

export function isEmptyObject(obj) {
  for (const t in obj) {
    if (obj.hasOwnProperty(t)) {
      return false
    }
  }
  return true
}

export function genSign(data) {
  const key = data.sessionid || dealCookie('sessionid') || ''
  let name
  let str = ''
  let i = 0
  const arr = []
  // if ('sessionid' in data) {
  //   delete data.sessionid
  // }
  for (name in data) {
    if (Object.prototype.hasOwnProperty.call(data, name)) {
      arr.push(name)
    }
  }
  const len = arr.length
  if (len > 0) {
    arr.sort()
    for (; i < len; i++) {
      if (!(String(data[arr[i]]) === '' || data[arr[i]] === undefined)) {
        str += arr[i] + '=' + data[arr[i]] + '&'
      }
    }
  }
  const sign = md5(str.substring(0, str.length - 1) + '&key=' + key)
  return sign
}

export default {
  addReadyEvent,
  addLoadEvent,
  ajaxJsonp,
  assign,
  clearAllCookie,
  clipboard,
  createURL,
  dealCookie,
  dealData,
  formaDate,
  formatDate,
  getAjax,
  getArrayVal,
  getBrowserUA,
  getBrowserVersion,
  getCurrentENV,
  getGameLink,
  getParam,
  getQueryString,
  getRandomString,
  getTopLevelDomain,
  initPage,
  isDomain,
  isEmptyObject,
  json2str,
  JSONParse,
  loadData,
  loadFile,
  log,
  mobileReg,
  objectToQuery,
  pageLoadedTime,
  queryGame,
  querystring,
  genSign,
  randomArray,
  setControlDownload,
  statipPageLoadedClient
}
